export default {
    "spotify_playlist_name": null,
    "spotify_playlist_link": null,
}